import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import logo from 'assets/images/logo/logo.png';
import { CSSTransitionGroup } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavHashLink as NavLink, HashLink as Link } from 'react-router-hash-link';
import { directoryUrl, storageKeys, name } from 'settings';

import {
  Account,
  APIHandler,
  Burger,
  DataHandler,
  Dropdown,
  SideMenu,
  StorageHandler,
  BackButton,
} from 'C4';

import * as settings from 'config/settings.json';

const resetScrollPosition = () => window.scrollTo(0, 0);

function pathTrim(path) {
  let index = path.length - 1;
  if (path.charAt(index) == '/') {
    path = path.slice(0, index);
  }
  return path;
}

class Nav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: false,
      firstName: 'Login',
      lastName: '',
      menuToggle: false,
      accountToggle: false,
      lastCheckedMessages: '',
      unreadMessageCount: '',
    };

    this.handleMenuToggle = this.handleMenuToggle.bind(this);
    this.handleAccountToggle = this.handleAccountToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentWillMount() {
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        this.setState({
          loggedIn: true,
          firstName: res.response.first_name,
          lastName: res.response.last_name,
          email: res.response.email,
        });
        DataHandler.requestWithId(APIHandler.getUserProgress, res.response.email).then((progress) => {
          if (progress.data) {
            const { chapters } = progress.data[0];
            this.setState({
              trainingComplete: chapters.every(chapter => chapter.progress >= chapter.total_pages),
            });
          }
        });
      } else {
        this.setState({ loggedIn: res });
      }
    });
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(APIHandler.getUnreadMessages, this.state.lastCheckedMessages).then((res) => {
      this.setState({ unreadMessageCount: res.missed_items[0].count });
    });
  }

  handleMenuToggle() {
    const container = document.getElementById('container');
    this.setState(prevState => ({
      menuToggle: !prevState.menuToggle,
    }));
    container.classList.remove('offsetContainer');
    window.scrollTo(0, 0);
  }

  handleAccountToggle() {
    this.setState(prevState => ({
      accountToggle: !prevState.accountToggle,
    }));
    this.checkForUnreadMessages();
  }

  handleClickOutside() {
    const container = document.getElementById('container');
    this.setState({ menuToggle: false, accountToggle: false });
    container.classList.remove('offsetContainer');
  }

  render() {
    const {
      accountToggle,
      email,
      firstName,
      lastName,
      loggedIn,
      menuToggle,
      trainingComplete,
      unreadMessageCount,
    } = this.state;
    const { pathname, secondary } = this.props;

    return (
      <div style={{ display: 'flex' }}>
        {!secondary && ((
          <React.Fragment>
            {settings.level1Paths.includes(pathTrim(pathname)) && (
              <div style={{ position: 'fixed' }}>
                <BackButton to="/main" />
              </div>
            )}
            {['/main/search', '/main/favorites', '/main/messages'].includes(pathTrim(pathname)) && (
              <div style={{ position: 'fixed' }}>
                <BackButton />
              </div>
            )}
          </React.Fragment>
        ))}
        <nav className="mini">
          <ul className="secondaryNav">
            <li className={loggedIn ? '' : 'disabled'}>
              <NavLink
                onClick={resetScrollPosition}
                activeClassName="is-active"
                to="/main/favorites"
              >
                <FontAwesomeIcon icon={['fal', 'heart']} />
              </NavLink>
            </li>
            <li className={loggedIn ? '' : 'disabled'}>
              <NavLink
                onClick={resetScrollPosition}
                activeClassName="is-active"
                to="/main/search"
              >
                <FontAwesomeIcon icon={['fal', 'search']} />
              </NavLink>
            </li>
            <li className={loggedIn ? '' : 'disabled'}>
              <NavLink
                onClick={resetScrollPosition}
                activeClassName="is-active"
                to="/main/messages"
              >
                <FontAwesomeIcon icon={['fal', 'envelope']} />
              </NavLink>
            </li>
            <li className={loggedIn ? ' ' : 'navLogin'}>
              {loggedIn ? (
                <Account
                  onClick={this.handleAccountToggle}
                  firstName={firstName}
                  expanded={accountToggle}
                />
              ) : (
                <NavLink exact to="/login">
                  <button className="account">
                    <FontAwesomeIcon icon={['fal', 'user']} />
                    {firstName}
                  </button>
                </NavLink>
              )}
            </li>
          </ul>
        </nav>

        <CSSTransitionGroup
          transitionName="accountToggle"
          transitionEnterTimeout={150}
          transitionLeaveTimeout={150}
        >
          {accountToggle && (
            <Dropdown
              handleClickOutside={this.handleClickOutside}
              outsideClickIgnoreClass="account"
              firstName={firstName}
              lastName={lastName}
              email={email}
              unreadMessageCount={unreadMessageCount}
              openSettings={this.openSettings}
              trainingComplete={trainingComplete}
              diploma={src => this.frame(src)}
            />
          )}
        </CSSTransitionGroup>
        <CSSTransitionGroup
          transitionName="menuToggle"
          transitionEnterTimeout={250}
          transitionLeaveTimeout={250}
        >
          {menuToggle && (
            <SideMenu
              handleClickOutside={this.handleClickOutside}
              outsideClickIgnoreClass="burgerMenu"
              firstName={firstName}
              lastName={lastName}
              email={email}
            />
          )}
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default Nav;

Nav.propTypes = {
  pathname: PropTypes.string,
  hideBackButton: PropTypes.bool,
  secondary: PropTypes.bool,
};

Nav.defaultProps = {
  pathname: '',
  hideBackButton: false,
  secondary: false,
};
